/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
// import * as eventService from '../services/eventService'
import * as stringParser from '../util/string.util'
import * as dateUtil from '../util/date.util'
// import Joinnowpopup from './sub_components/joinnowpopup'
// import Loginpopup from './sub_components/loginpopup'
// import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
// import AboutUs from './sub_components/aboutUs'
// import BettingRules from './sub_components/bettingRules'
// import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
// import PrivacyPolicy from './sub_components/privacyPolicy'
// import TermsAndConditions from './sub_components/termsAndConditions'
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
// import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
// import { SOCIALMEDIALINKS } from '../configs/apkFileName';
import UnderMaintenance from './under_maintenance';
import { BRANDLOGOFILENAME } from '../configs/authSignupConfig';
import Joinnowseocomp from './sub_components/joinNowSeoComp';
import JoinNowLoginSeoComp from './sub_components/joinNowLoginSeoComp';

import * as authUtil from "../util/auth.util";
import { SOCIALMEDIALINKS } from '../configs/apkFileName';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class JoinnowSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            inMaitanenceMessage: '',
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
            isJoinNow: true
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    componentWillMount() {
        utilService.checkMaintainanceCall().then((res) => {
            if (res.isSuccess && !!res.items && res.items.isMaintenance) {
                this.setState({
                    inMaitanence: true,
                    inMaitanenceMessage: res.items
                })
            }
        })
    }

    async componentDidMount() {
        localStorage.removeItem("homeData")
        localStorage.removeItem("userAuthDetail")
        localStorage.removeItem("tokenData")
        if (constants.isDev) {
            this.setState({ isDev: true })
        }
        let savedData = localStorage.getItem("rememberData")
        if (!!savedData) {
            savedData = JSON.parse(savedData)
            if (!!savedData && !!savedData.uid) {
                this.setState({ rememberMe: true, uid: savedData.uid, passcode: !!savedData.passcode ? savedData.passcode : "" })
            }
        }
        if (!window.location.href.includes("apk")) {
            this.setState({ showDownLoad: true })
            localStorage.setItem("appType", "web")
        } else {
            localStorage.setItem("appType", "mobile")
        }

        // eventService.getBaseHomeData().then((res) => {
        //     let homeData = this.parseBook(res)
        //     localStorage.setItem('homeData', JSON.stringify(homeData))
        //     localStorage.setItem('isBaseData', "true")
        // })

        // headers.append('Referrer-Policy', 'origin');
        // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
        // headers.append('Accept', '*/*');
        // headers.append('Access-Encoding', 'gzip, deflate, br');
        // headers.append('Connection', 'keep-alive');
        var options = {};
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        options.headers = headers;




        // let banners = await utilService.getBanner()
        // let banners = await utilService.getBannerListJson()
        // debugger
        // utilService.getBannerListJson().then((res)=>{
        //     if(!!res){
        //         let desktop_banners_arr = res.desktop
        //         let mobile_banners_arr = res.mobile

        //         let desktop_banners = {}
        //         for (var banner of desktop_banners_arr) {
        //             desktop_banners[banner.split(".")[0]] = `https://images.staticcontents.com/banners/desktop_banner_${banner}`
        //         }

        //         let mobile_banners = {}
        //         for (var mobbanner of mobile_banners_arr) {
        //             mobile_banners[mobbanner.split(".")[0]] = `https://images.staticcontents.com/banners/mobile_banner_${mobbanner}`
        //         }

        //         this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        //     }
        // })
        // utilService.getOperatorBannerListJson().then((res) => {
        //     if (!!res) {
        //         let desktop_banners_arr = res.desktop
        //         let mobile_banners_arr = res.mobile

        //         let desktop_banners = {}
        //         for (var banner of desktop_banners_arr) {
        //             desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`
        //         }

        //         let mobile_banners = {}
        //         for (var mobbanner of mobile_banners_arr) {
        //             mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`
        //         }

        //         this.setState({ operatorDesktopBanners: desktop_banners, operatorMobileBanners: mobile_banners },()=>{
        //             utilService.getBannerListJson().then((res) => {
        //                 if (!!res) {
        //                     let desktop_banners_arr = res.desktop
        //                     let mobile_banners_arr = res.mobile

        //                     let desktop_banners = {}
        //                     for (var banner of desktop_banners_arr) {
        //                         desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
        //                     }
        //                     let mobile_banners = {}
        //                     for (var mobbanner of mobile_banners_arr) {
        //                         mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
        //                     }

        //                     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        //                 }
        //             })
        //         })
        //     }
        // })
        // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

        //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
        //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

        //     let desktop_banners = {}
        //     for (var banner of desktop_banners_arr) {
        //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
        //     }

        //     let mobile_banners = {}
        //     for (var mobbanner of mobile_banners_arr) {
        //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
        //     }

        //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        // }
    }


    // showToast(msg, type) {
    //     let self = this
    //     this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
    //         setTimeout(() => {
    //             self.setState({ toastMsg: "", toastType: "", showToast: false })
    //         }, 3000);
    //     })
    // }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    handleKey(e) {
        if (e.keyCode === 13) {
            this.signIn();
        }
    }

    signIn() {
        let body = {
            "username": this.state.uid.trim().toLowerCase(),
            "password": this.state.passcode
        }
        if (!this.state.uid.trim()) {
            this.props.notify("Please Insert Username!", "error")
            return false
        }
        if (!this.state.passcode) {
            this.props.notify("Please Insert Password!", "error")
            return false
        }
        if (this.state.rememberMe) {
            let data = {
                "uid": this.state.uid.trim().toLowerCase(),
                "passcode": this.state.passcode
            }
            localStorage.setItem("rememberData", JSON.stringify(data))
        } else {
            localStorage.removeItem("rememberData")
        }
        authServices.signin(body).then(async (result) => {
            if (result.token) {
                let data = {
                    token: result.token
                }
                let accessControl = {
                    sports: true,
                    binary: true,
                    casino: true
                }
                localStorage.setItem("userAuthDetail", JSON.stringify(data))
                let velidateData = await authServices.velidateToken()

                if (!!velidateData.role && velidateData.role === "Client") {
                    localStorage.setItem("tokenData", JSON.stringify(velidateData))
                    localStorage.setItem("accessControl", JSON.stringify(accessControl))
                    let accData = await accountServices.getAccountData()
                    if (!!accData && !!accData.userLock && accData.userLock) {
                        this.props.notify("User Is Locked. Please Contact Upperline!", "error")
                        authUtil.logout();
                    }
                    localStorage.setItem("accountData", JSON.stringify(accData))
                    let configData = await authServices.getConfigButton()
                    localStorage.setItem("buttonsValues", JSON.stringify(configData))
                    if (velidateData.pwdch) {
                        this.props.history.push("/setpassword");
                    }
                    else {
                        // this.props.history.push("/home");
                        window.location.href = "/home"
                    }
                } else if (!!velidateData.role && velidateData.role !== "Client") {
                    this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
                } else {
                    this.props.notify(velidateData.exception.message, "error")
                }
            } else {
                this.props.notify(result.exception.message, "error")
            }
        })
    }

    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
    }

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // parseBook(data) {
    //     !!data && data.length > 0 && data.forEach((mkt, i) => {
    //         // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
    //         let eventMeta = {}
    //         eventMeta.hasBookMaker = !!mkt.metadata && !!mkt.metadata.hasBookMaker && mkt.metadata.hasBookMaker === "True" ? "true" : "false"
    //         eventMeta.hasSession = !!mkt.metadata && !!mkt.metadata.hasSession && mkt.metadata.hasSession === "True" ? "true" : "false"
    //         eventMeta.hasTv = !!mkt.metadata && !!mkt.metadata.hasTv && mkt.metadata.hasTv === "True" ? "true" : "false"
    //         let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz(mkt.metadata.book) : null
    //         if (mkt.eventType.id === "300") {
    //             data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(mkt.catalogue.marketName)
    //             data[i].symbolType = !!mkt.metadata && !!mkt.metadata.symbol_type ? mkt.metadata.symbol_type : null
    //             data[i].eventId = mkt.event.id
    //             data[i].eventName = mkt.event.name
    //             data[i].competitionName = mkt.competition.name
    //         }
    //         // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
    //         data[i].metadata = {}
    //         data[i].metadata.book = book
    //         data[i].metadata.eventMeta = eventMeta
    //         // if(!!market_end_time){
    //         //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
    //         //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
    //         // }
    //     })
    //     return data
    // }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    toggleIsJoinNow() {
        this.setState({ isJoinNow: !this.state.isJoinNow })
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (
            <>
                {
                    !this.state.inMaitanence ?
                        <div className="radheexch radheexchlogin  bg-white-login-seo">
                            <header className='seoheader'>
                                {/* <ReCAPTCHA
                        // size={"invisible"}
                        ref={recaptchaRef}
                        sitekey={ReCAPTCHA_KEY}
                    /> */}
                                <div className="container-fluid">
                                    {/* {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV ONLINE</span>} */}
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div className="logo seo-logo-header">
                                                <a href='/' className='back-arrow'><i className="fa fa-angle-left" aria-hidden="true"></i></a>
                                                <a href=""><img src={`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} width="195" height="60px" alt="logo" /></a>
                                                <span>&nbsp;</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                            <section className='seobanner'>
                                <div className='seobannerdesktop'><img alt="Deposit Bonus Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/seobanner.webp"} /></div>
                                <div className='seobannermobile'><img alt="Deposit Bonus Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/seobanner-mobile.webp"} /></div>
                            </section>
                            <section className='claimbonus '>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-12 claimnow text-center'>
                                            <div className='d-inline-block mr-3'>To Claim Bonus: <i className="fa fa-whatsapp mr-2" aria-hidden="true"></i><a href={!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} className='claimnumber' target='_blank'>{!!SclMd &&(SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber)}</a></div>
                                            <div className='d-inline-block'>For Support: <i className="fa fa-whatsapp mr-2" aria-hidden="true"></i><a href={!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} className='claimnumber' target='_blank'>{!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsappDisplayNumber)}</a></div>
                                        </div>
                                        <div className='col-12 mt-2 '>
                                            To claim bonus, support or for any queries please contact us on the numbers given above.
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='joinnow-seo'>
                                {/* LOGIN FORM START */}
                                <div className='joinnowseobox-width'>
                                    {this.state.isJoinNow ?
                                        <Joinnowseocomp toggleIsJoinNow={() => this.toggleIsJoinNow()} notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} />
                                        :
                                        <JoinNowLoginSeoComp toggleIsJoinNow={() => this.toggleIsJoinNow()} notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} />
                                    }
                                </div>
                                {/* LOGIN FORM END */}
                            </section>
                        </div>
                        :
                        <UnderMaintenance inMaitanenceMessage={this.state.inMaitanenceMessage} />
                }
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(JoinnowSEO);